import { vars } from "@common/styles";
import styled from "styled-components";

export const AppModuleHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 4rem;
`;

export const AppNavContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 1.4rem;
`;

export const AppImage = styled.img`
  width: 3.8rem;
  height: 3.8rem;
  border-radius: 0.8rem;
  object-fit: cover;
`;

export const SlashImage = styled.img`
  width: 2.4rem;
  height: 2.4rem;
  margin-left: 0.8rem;
  margin-right: 0.8rem;
`;

export const AppNavigation = styled.nav`
  display: flex;
  gap: 0.4rem;
  position: relative;
  border: 1px solid ${vars.colors.grey90};
  border-radius: 1.4rem;
  padding: 0.4rem;

  div {
    color: ${vars.colors.grey60};
    position: relative;
    display: flex;
    align-items: center;
    line-height: 1.25;
    border-radius: 1rem;
    border: 1px solid transparent;
    transition: ${vars.transitions.hover};
    cursor: pointer;
    user-select: none;

    &:hover {
      text-decoration: none;
      color: ${vars.colors.white};
      background-color: ${vars.colors.grey100};
      border: 1px solid transparent;
    }

    &.active {
      color: ${vars.colors.white};
      background-color: ${vars.colors.grey100};
      border: 1px solid ${vars.colors.grey80};

      &:hover {
        color: ${vars.colors.white};
      }
    }
    a {
      text-decoration: none;
      width: 100%;
      padding: 0.9rem 1.6rem 1.1rem 1.6rem;
      font-size: 1.4rem;

      color: ${vars.colors.grey50};

      &:hover {
        color: ${vars.colors.white};
      }

      &.active {
        color: ${vars.colors.white};
      }
    }
  }
`;

export const NoAppsCard = styled.div`
  padding: 3.2rem;
  border-radius: 2rem;
  background-color: ${vars.colors.grey100};
  margin-bottom: 1.2rem;
`;
